import { useState, useEffect } from "react";

const STORAGE_KEY = "orthoped:staging:authed";
const STAGING_HOST = "staging.orthoped.ai";
const STAGING_PASSWORD = "orthoped2026";

const StagingGate = ({ children }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [authed, setAuthed] = useState(false);

  const isStaging = window.location.hostname === STAGING_HOST;

  useEffect(() => {
    if (!isStaging) return;
    setAuthed(sessionStorage.getItem(STORAGE_KEY) === "1");
  }, [isStaging]);

  if (!isStaging || authed) return children;

  const onSubmit = (e) => {
    e.preventDefault();
    setError("");
    if (password === STAGING_PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, "1");
      setAuthed(true);
    } else {
      setError("Incorrect password.");
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F8F8] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img
            src="/logoImage.svg"
            alt="OrthoPed"
            className="h-10 mx-auto mb-4"
          />
          <span className="inline-block px-3 py-1 text-xs font-semibold uppercase tracking-wider text-amber-700 bg-amber-50 border border-amber-200 rounded-full">
            Staging Environment
          </span>
        </div>

        <form
          onSubmit={onSubmit}
          className="bg-white rounded-2xl shadow-lg border border-neutral-100 p-8"
        >
          <label
            htmlFor="staging-pw"
            className="block text-sm font-medium text-neutral-700 mb-2"
          >
            Password
          </label>
          <input
            id="staging-pw"
            type="password"
            placeholder="Enter staging password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            className="w-full px-4 py-3 rounded-xl border border-neutral-200 text-base outline-none focus:ring-2 focus:ring-[#005BA8]/30 focus:border-[#005BA8] transition-all"
          />
          {error && (
            <p className="mt-2 text-sm text-red-600 font-medium">{error}</p>
          )}
          <button
            type="submit"
            className="mt-4 w-full py-3 rounded-xl bg-[#005BA8] text-white font-semibold text-sm hover:bg-[#004A8C] transition-colors"
          >
            Unlock
          </button>
        </form>
      </div>
    </div>
  );
};

export default StagingGate;
